import { __decorate } from "tslib";
import { CrudServiceFactory, AppRequestService } from '@core/frontend-shared/api';
import { from, Observable, of } from 'rxjs';
import { isAppRequest } from '@core/shared/app-request';
import { ClassName, getClassName } from '@core/shared/class-name';
export class FormServiceSaveHandlerFunction {
  constructor(fs, injector, func) {
    this.fs = fs;
    this.injector = injector;
    this.func = func;
    this.returnsUpdatedFormData = false;
  }
  execute(value) {
    const result = this.func(value, this.fs);
    if (result instanceof Promise) return from(result);else if (result instanceof Observable) return result;else return of(value);
  }
}
export class FormServiceSaveHandlerNoop extends FormServiceSaveHandlerFunction {
  constructor(fs, injector) {
    super(fs, injector, v => v);
    this.fs = fs;
    this.injector = injector;
  }
}
export class FormServiceSaveHandlerApiRequest {
  constructor(fs, injector) {
    this.fs = fs;
    this.injector = injector;
    this.returnsUpdatedFormData = false;
  }
  execute(value) {
    if (Array.isArray(value)) throw new Error('FormServiceSaveHandlerApiRequest does not support saving arrays yet!');
    const service = this.injector.get(AppRequestService);
    const req = this.submitData(service, value);
    return req;
  }
  submitData(service, value) {
    if (isAppRequest(this.fs.modelFactory.Model)) {
      return service.sendRequest(this.fs.modelFactory.Model, value);
    } else {
      console.log('this model is no decorated Model or ItemModel. Cannot submit to API.', this.fs.modelFactory.Model);
      throw new Error('this model is no decorated Model or ItemModel. Cannot submit to API.');
    }
  }
}
export class FormServiceSaveHandlerApiItemBase {
  constructor(fs, injector) {
    this.fs = fs;
    this.injector = injector;
    this.returnsUpdatedFormData = true;
  }
  setService(service) {
    this.service = service;
  }
  execute(value) {
    if (Array.isArray(value)) throw new Error(getClassName(this) + ' does not support saving arrays yet!');
    const service = this.resolveCrudService();
    const req = service.save(value);
    return req;
  }
  resolveCrudService() {
    if (this.service) {
      return this.service;
    }
    const definitionOptions = this.fs.getEditorModelInfo().definition.options;
    if (!definitionOptions.useCrudEndpoint) {
      throw new Error(getClassName(this) + ' error: formService Model is not configurated for submission to CrudEndpoint / by CrudService!');
    }
    const factory = this.injector.get(CrudServiceFactory);
    const service = factory.useDestroyRef(this.fs.getDestroyRef()).createCrudService(this.fs.modelFactory.Model);
    service.useCrudEndpoint(definitionOptions.useCrudEndpoint);
    return service;
  }
}
let FormServiceSaveHandlerSubmitOnlyApiItem = /*#__PURE__*/(() => {
  let FormServiceSaveHandlerSubmitOnlyApiItem = class FormServiceSaveHandlerSubmitOnlyApiItem extends FormServiceSaveHandlerApiItemBase {
    constructor() {
      super(...arguments);
      this.returnsUpdatedFormData = false;
    }
  };
  FormServiceSaveHandlerSubmitOnlyApiItem = __decorate([ClassName('FormServiceSaveHandlerSubmitOnlyApiItem')], FormServiceSaveHandlerSubmitOnlyApiItem);
  return FormServiceSaveHandlerSubmitOnlyApiItem;
})();
export { FormServiceSaveHandlerSubmitOnlyApiItem };
let FormServiceSaveHandlerEditableApiItem = /*#__PURE__*/(() => {
  let FormServiceSaveHandlerEditableApiItem = class FormServiceSaveHandlerEditableApiItem extends FormServiceSaveHandlerApiItemBase {
    constructor() {
      super(...arguments);
      this.returnsUpdatedFormData = true;
    }
  };
  FormServiceSaveHandlerEditableApiItem = __decorate([ClassName('FormServiceSaveHandlerEditableApiItem')], FormServiceSaveHandlerEditableApiItem);
  return FormServiceSaveHandlerEditableApiItem;
})();
export { FormServiceSaveHandlerEditableApiItem };